<!-- 工作台 -->
<template>
  <div>
    <div class="form-main">
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="120px"
        class="formData"
      >
        <div>
          <el-form-item label="公告标题" prop="Title">
            <el-input v-model="formData.Title"></el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="公告内容" prop="Content">
            <el-input
              type="textarea"
              maxlength="200"
              show-word-limit
              v-model="formData.Content"
            ></el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="公告发布时间">
            <el-date-picker
              v-model="formData.PublishTime"
              type="datetime"
              placeholder="选择日期时间"
              default-time="12:00:00"
            >
            </el-date-picker>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="可看联盟角色">
            <el-select
              v-model="formData.RoleIds"
              multiple
              remote
              filterable
              allow-create
              placeholder="请选择角色名称"
              :remote-method="querySearch"
              v-select-scroll-more="searchRoleLoad"
              style="width: 100%"
            >
              <el-option
                v-for="item in roleOptions"
                :key="item.RoleId"
                :label="item.RoleName"
                :value="item.RoleId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="停止展示时间">
            <el-date-picker
              v-model="formData.StopShowTime"
              type="datetime"
              placeholder="选择日期时间"
              default-time="12:00:00"
            >
            </el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="cancel()">关闭</el-button>
        <el-button class="btn-primary" @click="submitRoleForm">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["noticeId"],
  name: "",
  data() {
    return {
      formData: {
        UnionId: this.$util.getLocalStorage("currentUnion"),
        RoleIds: [],
        NoticeId: "",
        Title: "",
        Content: "",
        PublishTime: "",
        StopShowTime: "",
      },
      roleForm: {
        Page: 1,
        Limit: 10,
        stopLoad: false,
        key: "",
      },
      roleOptions: [],
      rules: {
        Title: [
          {
            required: true,
            message: "公告标题必填",
            trigger: "blur",
          },
        ],
        Content: [
          {
            required: true,
            message: "公告内容必填",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    if (this.noticeId) {
      this.formData.NoticeId = this.noticeId;
      this.getNoticeInfo();
    }
    this.querySearch();
  },
  methods: {
    getNoticeInfo() {
      let url = "/api/EntpUnions/GetUnionNoticeById";
      this.$util
        .axiosGet({
          url: url,
          data: {
            UnionId: this.formData.UnionId,
            NoticeId: this.formData.NoticeId,
          },
        })
        .then((res) => {
          if (res.data) {
            this.formData = res.data;
          }
        })
        .catch(() => {});
    },
    // 提交表单
    submitRoleForm() {
      let that = this;
      that.$refs.formData.validate((valid) => {
        if (valid) {
          let url = "/api/EntpUnions/SubmitUnionNotice";
          that.$util
            .axiosPost({
              url: url,
              data: that.formData,
            })
            .then((res) => {
              that.$util.successMsg(res.errmsg);
              that.$emit("closeDialog", true);
            })
            .catch(() => {});
        } else {
          this.$util.errorMsg("校验不通过");
          return false;
        }
      });
    },
    cancel() {
      this.$emit("closeDialog");
    },
    // 获取角色列表
    querySearch(key) {
      if (![undefined].includes(key)) {
        this.roleForm.Page = 1;
        this.roleForm.stopLoad = false;
        this.roleForm.key = key;
        this.roleOptions = [];
      }
      if (this.roleForm.stopLoad) return;
      this.$util
        .getUnionRoleList(
          this.roleForm.key,
          this.roleForm.Page,
          this.roleForm.Limit
        )
        .then((data) => {
          if(!data) return;
          this.roleForm.stopLoad = data.length < this.roleForm.Limit;
          this.roleOptions = this.$util.uniqueArr(this.roleOptions, data);
        });
    },
    searchRoleLoad() {
      this.roleForm.Page += 1;
      this.querySearch();
    },
  },
};
</script>
<style lang="less" scoped>
.form-value {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  color: #606266;
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  width: 100%;
}
.form-column {
  width: 33.33%;
}
.dialog-footer {
  text-align: right;
}
</style>
